"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var HeaderFlexPane_1 = require("./HeaderFlexPane");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var owa_feedback_1 = require("owa-feedback");
var mobx_react_1 = require("mobx-react");
var styles = require('./FeedbackPane.scss');
var FeedbackPane = /** @class */ (function (_super) {
    tslib_1.__extends(FeedbackPane, _super);
    function FeedbackPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSend = function () {
            _this.props.onDismiss();
        };
        return _this;
    }
    FeedbackPane.prototype.renderFeedbackForm = function () {
        return (React.createElement("div", { className: styles.menuFeedback },
            React.createElement(owa_feedback_1.FeedbackForm, { onSendFeedback: this.onSend })));
    };
    FeedbackPane.prototype.render = function () {
        return (React.createElement(HeaderFlexPane_1.default, { title: function () { return owa_common_strings_1.default.feedbackCharm_ariaLabel; }, content: this.renderFeedbackForm(), onDismiss: this.props.onDismiss }));
    };
    FeedbackPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], FeedbackPane);
    return FeedbackPane;
}(React.Component));
exports.default = FeedbackPane;
//# sourceMappingURL=FeedbackPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/FeedbackPane.js
// module id = 6213
// module chunks = 38